module.exports = "/wp-content/plugins/farmacy/assets/js/images/cat_concentrates_label-5d86a523ba867545b7387660beb8e952.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/menu/common/menu-item-thumb/img/cat_concentrates_label.png
 ** module id = 154
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 17 22 25 26
 **/